import React, { useEffect, useState } from 'react';
import { Input, DatePicker, Select } from 'antd';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import Pagination from '../../../components/pagination/Pagination.jsx';
import columns from '../../../columns/ib/Transactions.js';
const { RangePicker } = DatePicker;

export default function Transactions() {

    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0)

    useEffect(() => {
        setData(data?.map((item) => {
            return ({
                ...item,
                status: (<div className='bg-[#2D9B6333] flex justify-center items-center rounded'><p className='px-3 py-1 rounded-full uppercase text-xs text-center success_tag'>Success</p></div>)
            })
        }))
    }, []);

    const handleChange = () => { }

    const handleSubmit = (e) => {
        e.preventDefault();
    }

    return (
        <div>
            <div className="flex justify-end flex-wrap gap-5">
                <div className="flex items-center">
                    <div className="mr-3">
                        <Input
                            size="large"
                            style={{ width: 220 }}
                            placeholder="Search"
                            prefix={
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                                    <path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clip-rule="evenodd" />
                                </svg>
                            }
                        />
                    </div>
                    <div>
                        <button className="bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500">Search</button>
                    </div>
                </div>
            </div>

            <div className='bg-primary-light rounded-lg p-4 my-5'>
                <form className='w-full' autoComplete="off" onSubmit={handleSubmit}>
                    <div className='grid sm:grid-cols-2 md:grid-cols-4 gap-4'>
                        <div>
                            <label className='text-base text-[#2F2B3DCC] font-medium'>Date Range</label>
                            <RangePicker className='border-primary w-full mt-1 py-2' format='DD-MM-YYYY' />
                        </div>
                        <div>
                            <label className='text-base text-[#2F2B3DCC] font-medium'>Category</label>
                            <Select
                                className='border-primary w-full mt-1'
                                onChange={handleChange}
                                placeholder='Select a category'
                                options={[
                                    { value: '0', label: 'Fail' },
                                    { value: '1', label: 'Success' }
                                ]}
                            />
                        </div>
                        <div className="md:mt-7 flex items-center gap-5">
                            <button type='submit' className='bg-primary text-sm text-white font-medium uppercase px-6 py-2 rounded-lg themeHover duration-500'>Submit</button>
                            <button className="flex items-center bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 mr-2">
                                    <path fill-rule="evenodd" d="M11.47 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06l-3.22-3.22V16.5a.75.75 0 0 1-1.5 0V4.81L8.03 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5ZM3 15.75a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" />
                                </svg>
                                Export
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <div className="border-[2px] border-[#F4EFFD] rounded-xl pt-4 lg:pt-6 w-full mt-5">
                <div className="px-4 lg:px-6">
                    <p className="text-[#2F2B3D] text-xl font-semibold">Transactions</p>
                </div>
                <div className="my-6">
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
                    <Pagination total={100} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
                </div>
            </div>
        </div>
    )
}